import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';

export function defaultSortState<T>(a: T, b: T, sortState: Sort) {
  const aValue = a[sortState.active] ?? '';
  const bValue = b[sortState.active] ?? '';
  return sortState.direction === 'asc'
    ? aValue
        .toString()
        .toLowerCase()
        .localeCompare(bValue.toString().toLowerCase())
    : bValue
        .toString()
        .toLowerCase()
        .localeCompare(aValue.toString().toLowerCase());
}

export function getPaginatedData<T>(
  data: T[],
  { pageIndex, pageSize }: PageEvent,
) {
  const startIndex = pageIndex * pageSize;
  const endIndex = startIndex + pageSize;

  return data.slice(startIndex, endIndex);
}

export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50];
export const DEFAULT_PAGE_EVENT: PageEvent = {
  pageIndex: 0,
  pageSize: 10,
  length: 0,
};
export const DEFAULT_SORT_STATE: Sort = {
  active: '',
  direction: 'asc',
};
